import { Component, OnInit } from '@angular/core';

import { LocalStorageService } from 'angular-2-local-storage';

import { Sucursal } from '../../model/sucursal';
import { Consorcio } from '../../model/consorcio';
import { ReporteInventario } from '../../model/reporte-inventario';

import { ReporteListaEmpaque } from '../../model/reporte-lista-empaque';

import { ConsorciosService } from '../../services/consorcios.service';
import { SucursalService } from '../../services/sucursal.service';
import { ReporteInventarioService } from '../../services/reporte-inventario.service';

@Component({
  selector: 'app-reporte-lista-empaque',
  templateUrl: './reporte-lista-empaque.component.html',
  styleUrls: ['./reporte-lista-empaque.component.css']
})

export class ReporteListaEmpaqueComponent implements OnInit {

  public fechaActual: Date;
  public filtro: boolean;
  public codigoSucursal: string;
  public consorcio: Consorcio;
  public consorcios: Consorcio[];
  public inventarios: ReporteInventario[];

  public sucursal: Sucursal;
  public sucursales: Sucursal[];
  public codigoArticulo: string;
  public nombreArticulo: string;
  public usuario: string;
  public _filtro: string;

  public buscando: boolean;

  public documentosSeleccionadosVisual: string;
  public codigoDocumento: string;

  public editMode: boolean;


  public empaque: ReporteListaEmpaque[];

  public documentos: string[];


  public criterio: any;

  public query: any;


  constructor(
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService,
    private _inventario: ReporteInventarioService
  ) { }

  ngOnInit() {

    this._filtro = "";
    this.editMode = false;

    this.documentos = [];
    this.empaque = [];
    this.buscando = false;

    this.usuario = sessionStorage.getItem("login");

    this.codigoArticulo = "";
    this.nombreArticulo = "";

    this.fechaActual = new Date();
    this.filtro = true;

    this.cargarConsorcios();

  }

  cargarConsorcios() {

    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
        this.buscando = false;;
      });
  }

  cargarSucursales() {
    if (this.consorcio === null) {
      return;
    }
    this.query = { "email": sessionStorage.getItem("login"), "codigoConsorcio": this.consorcio.codigoConsorcio }

    this._sucursalService.getSucursalesUsuario(this.query)
      .subscribe(
      data => this.sucursales = data,
      err => {
        console.clear();
        console.log(err._body);
      });

  }

  filtroToggle() {
    this.filtro = !this.filtro;
  }


  realizarConsulta() {

    if (this.consorcio === undefined) {
      return;
    }

    if (this.codigoSucursal === "") {
      return;
    }

    this.buscando = true;

    this.query = { "ETIQUETA": "EMPAQUE", "QUERY": "codigoConsorcio:" + this.consorcio.codigoConsorcio + "|" + "codigoSucursal:" + this.codigoSucursal + "|" + "expediciones:" + this.documentosSeleccionadosVisual };

    console.log(this.query);

    this._inventario.getListaEmpaque(this.query)
      .subscribe(
      data => {
        this.empaque = data;
        this.buscando = false;
        console.clear();
        console.log("==========================REPORTE DE SERIES==========================");
        console.log(this.empaque);


      },
      err => {
        this.buscando = false;
        console.log(err._body);
      });

    this.filtro = false;
  }


  agregarDocumento() {


    this.documentos.push(this.codigoDocumento);


    var lista = "";

    for (let doc of this.documentos) {
      lista = lista + "''" + doc + "'',";
    }


    this.documentosSeleccionadosVisual = lista;

    this.codigoDocumento = "";


  }

  toggleEdit() {
    this.editMode = !this.editMode;
  }

  exportar() {
    this.editMode = false;
    var arr = this.empaque;
    var ar = arr;

    //comprobamos compatibilidad
    if (window.Blob && (window.URL)) {
      var contenido = "", d = new Date(), blob, _reader, save, clicEvent;
      //creamos contenido del archivo
      for (var i = 0; i < ar.length; i++) {
        //construimos cabecera del csv
        if (i == 0)
          contenido += Object.keys(ar[i]).join(";") + "\n";
        //resto del contenido
        contenido += Object.keys(ar[i]).map(function (key) {
          return ar[i][key];
        }).join(";") + "\n";
      }
      //creamos el blob
      blob = new Blob(["\ufeff", contenido], { type: 'text/csv' });
      //creamos el reader
      _reader = new FileReader();
      _reader.onload = function (event) {
        //escuchamos su evento load y creamos un enlace en dom
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        //aquí le damos nombre al archivo
        save.download = "ReporteListaEmpaque" + d.getDate() + "_" + (d.getMonth() + 1) + "_" + d.getFullYear() + ".csv";
        try {
          //creamos un evento click
          clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        } catch (e) {
          //si llega aquí es que probablemente implemente la forma antigua de crear un enlace
          clicEvent = document.createEvent("MouseEvent");
          clicEvent.initEvent('click', true, true);
        }
        //disparamos el evento
        save.dispatchEvent(clicEvent);
        //liberamos el objeto window.URL
        (window.URL).revokeObjectURL(save.href);
      }
      //leemos como url
      _reader.readAsDataURL(blob);
    } else {
      //el navegador no admite esta opción
      alert("Su navegador no permite esta acción");
    }
  }

  imprimir() {

    this.editMode = false;

    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/reporte-lista-empaque/reporte-lista-empaque.component.ts